import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  MoreVert,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Typography,
} from '@locus-taxy/disco-ui';
import { Workflow as SchemaIcon } from 'lucide-react';
import type { TranslateFunction } from '@locus-taxy/encore-i18n-toolkit';
import { getTestId } from '@locus-taxy/encore-utils';
import { useRouteContext } from '../../hooks/useRouteContext';
import { TestIdAction } from '../../utils/testIdUtils';

interface MoreActionsMenuProps {
  onViewSchema?: () => void;
  t: TranslateFunction;
}

export default function MoreActionsMenu({
  onViewSchema,
  t,
}: Readonly<MoreActionsMenuProps>) {
  const { entity, page } = useRouteContext();
  const moreOptionsTooltip = t(
    'dashboard.entityDetails.moreOptions',
    'More options'
  );

  return (
    <DropdownMenu>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                aria-label={moreOptionsTooltip}
                data-testid={getTestId({
                  action: TestIdAction.OPEN,
                  object: 'more-actions',
                  entity: entity ?? undefined,
                  page: page ?? 'details',
                })}
              >
                <MoreVert className="size-4" />
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent>{moreOptionsTooltip}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <DropdownMenuContent align="end">
        {onViewSchema && (
          <DropdownMenuItem
            onSelect={onViewSchema}
            data-testid={getTestId({
              action: TestIdAction.VIEW_SCHEMA,
              object: 'view-schema',
              entity: entity ?? undefined,
              page: page ?? 'details',
            })}
          >
            <SchemaIcon className="size-4" />
            <Typography variant="body2" component="span">
              {t('dashboard.entityDetails.viewSchema', 'View Schema')}
            </Typography>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
